module.exports = {"522622100":"新州镇","522622101":"旧州镇","522622102":"重安镇","522622103":"谷陇镇","522622104":"平溪镇","522622105":"野洞河镇","522622106":"浪洞镇","522622107":"上塘镇","522622203":"一碗水乡","522622204":"纸房乡","522622206":"翁坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522622.json
// module id = 2645
// module chunks = 0